export class AnioLink {

	public anio: number;
	public link: string;
	public rest: boolean;

}

export class DFormato {

	public ideFormato:  number;
	public nombre: string;
	public nombreCorto: string;
	public descripcion: string;
	public anios: AnioLink[];
	public visibleEnSelector: boolean;
	public ideGrupo: number;
	public valUriThumbnail: string;
	public redireccionar: string;

}


// WEBPACK FOOTER //
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/to/dformato.ts